import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Scope } from 'informed';
import { Grid } from 'react-md';
import { withStyles } from '@material-ui/core/styles';
import { filter, get } from 'lodash-es';

import DateField from '../../Common/DatePickerField';
import HiddenField from '../../Common/HiddenField';
import NumericField from '../../Common/NumericField';
import PercentField from '../../Common/PercentField';
import Select from '../../Common/Select';
import SwitchFieldMU from '../../Common/SwitchFieldMU';
import TextField from '../../Common/TextField';
import CoverageAmount from './CoverageAmount';

class CoverageFieldsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: '',
      packageDef: undefined,
      values: undefined,
      isReady: false,
      hasMDC: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { values: nextValues, package: nextPackage, coverage: nextCoverage } = nextProps;
    const { values: prevValues } = prevState;
    let newState = null;
    if (
      typeof nextValues !== 'undefined' &&
      typeof nextCoverage !== 'undefined' &&
      !_.isEqual(nextValues, prevValues)
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      newState = { ...newState, values: { ...nextValues } };
      // ===
      if (nextCoverage) {
        const defaultPackageDef = [];
        const extractValue = (name, code) => {
          try {
            return nextValues.coverage[name].extra[code];
          } catch (e) {
            return undefined;
          }
        };
        _.forOwn(nextCoverage, (coverage, name) => {
          defaultPackageDef.push({
            ...coverage,
            code: name,
            extra: Array.isArray(coverage.extra)
              ? coverage.extra.map(extra => Object.assign(extra, { initialValue: extractValue(name, extra.code) }))
              : undefined,
          });
        });
        let packageDef = [];
        // if no package defined then display all coverages
        if (_.isEmpty(nextPackage)) {
          packageDef = defaultPackageDef;
        } else if (nextPackage && nextValues && nextValues.package && nextPackage[nextValues.package] && nextCoverage) {
          packageDef = nextPackage[nextValues.package].options.map(option => ({
            ...nextCoverage[option],
            code: option,
            extra: Array.isArray(nextCoverage[option].extra)
              ? nextCoverage[option].extra.map(extra =>
                Object.assign(extra, { initialValue: extractValue(option, extra.code) })
              )
              : undefined,
          }));
        } else if (
          nextPackage &&
          defaultPackageDef[0] &&
          nextPackage[defaultPackageDef[0].code] &&
          nextPackage[defaultPackageDef[0].code].options
        ) {
          packageDef = _.values(nextPackage)[0].options.map(option => ({
            ...nextCoverage[option],
            code: option,
            extra: Array.isArray(nextCoverage[option].extra)
              ? nextCoverage[option].extra.map(extra =>
                Object.assign(extra, { initialValue: extractValue(option, extra.code) })
              )
              : undefined,
          }));
        }
        newState = { ...newState, packageDef, isReady: true };
      }
    }
    return newState;
  }

  componentDidMount() {
    this.hasMontantDeCouverture();
  }

  componentDidUpdate(prevProps) {
    const { covered } = this.props;
    if (!_.isEqual(prevProps.covered, covered)) {
      this.hasMontantDeCouverture();
    }
  }

  // TODO: improve API/CALC to allow "regular" extra field related to rules (with default data / options)
  hasMontantDeCouverture = () => {
    const { covered } = this.props;
    let nat;
    let test = false;
    // extract only first type...
    if (covered) {
      _.forIn(covered, value => {
        if (value.native) {
          nat = value.native;
          return false;
        }
        return true;
      });
    }
    if (nat) {
      _.forIn(nat, (value, key) => {
        if (key === 'montant_de_couverture') {
          test = true;
          return false;
        }
        return true;
      });
    }
    this.setState({ hasMDC: test });
  };

  render() {
    const { ...props } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { strings, values, classes, readOnly, i18n } = props;
    const { packageDef, selectedValue, isReady, hasMDC } = this.state;

    const renderCoverageField = model => {
      const {
        name,
        code,
        placeholder,
        selection,
        // sorted,
        // business_kind,
        technical_kind: technicalKind,
        required,
        sub_data: subData,
        initialValue,
      } = model; // eslint-disable-next-line camelcase
      const coverageFields = [];

      const defaultValue = get(model, 'default', undefined);

      switch (technicalKind) {
        case 'selection': {
          const options = Array.isArray(selection)
            ? selection.map(option => ({ text: option[1], value: option[0] }))
            : [];
          coverageFields.push(
            <Select
              className="field select"
              key={code}
              field={code}
              id={`select-${code}`}
              name={code}
              shrink
              label={name}
              options={options}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue}
              initialValue={initialValue || defaultValue}
              required={!!required}
              disabled={readOnly}
            />
          );
          break;
        }
        case 'numeric':
        case 'integer':
          coverageFields.push(
            <NumericField
              className="field number"
              key={code}
              field={code}
              id={`numberfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue}
              initialValue={initialValue || defaultValue}
              disabled={readOnly}
              lang={i18n.lang}
              technicalKind={technicalKind}
            />
          );
          break;
        case 'boolean':
          coverageFields.push(
            <SwitchFieldMU
              className="field boolean"
              key={code}
              field={code}
              id={`booleanfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue}
              initialValue={!!initialValue || !!defaultValue}
              disabled={readOnly}
            />
          );
          break;
        case 'percent':
          coverageFields.push(
            <PercentField
              className="field percent"
              key={code}
              field={code}
              id={`percentfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue}
              initialValue={initialValue || defaultValue}
              disabled={readOnly}
            />
          );
          break;
        case 'date':
          coverageFields.push(
            <DateField
              className="field date"
              key={code}
              field={code}
              id={`datefield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue}
              initialValue={initialValue || defaultValue}
              disabled={readOnly}
            />
          );
          break;
        default:
          coverageFields.push(
            <TextField
              className="field text"
              key={code}
              field={code}
              id={`textfield-${code}`}
              name={code}
              shrink
              label={name}
              placeholder={placeholder}
              required={!!required}
              onChange={value => this.setState({ selectedValue: value })}
              value={selectedValue}
              initialValue={initialValue || defaultValue}
              disabled={readOnly}
            />
          );
      }

      let subCoverageField = [];
      if (Array.isArray(subData) && subData.length > 0) {
        subCoverageField = subData.map(sub => {
          const coverage = filter(values.coverage, cov => !!get(cov, `extra[${code}]`))[0];

          const subCoverageFieldDesc =
            values && coverage && [code] && sub[1] === coverage.extra[code] ? sub[2] : undefined;
          try {
            if (subCoverageFieldDesc) return renderCoverageField(subCoverageFieldDesc);
          } catch (error) {
            return undefined;
          }
          return undefined;
        });
        coverageFields.push(subCoverageField);
      }

      return coverageFields;
    };

    if (isReady && Array.isArray(packageDef) && packageDef.length > 0) {
      return (
        <Grid className="grid coverage">
          <Scope scope="coverage">
            <Paper className={classes.root}>
              <Table className={`${classes.table} table-coverages`}>
                <TableHead>
                  <TableRow>
                    <TableCell>{strings['block.covered.coverage.field.coverage.label']}</TableCell>
                    <TableCell>{strings['block.covered.coverage.field.extra.label']}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {packageDef.map(row =>
                    row.code ? (
                      <TableRow key={`extra-${row.id}`}>
                        <Scope scope={row.code}>
                          <TableCell component="th" scope="row" className="table-cell-1">
                            {row.name}
                          </TableCell>
                          <TableCell className="table-cell-2">
                            {Array.isArray(row.extra) ? (
                              <Scope scope="extra">{row.extra.map(extra => renderCoverageField(extra))}</Scope>
                            ) : undefined}
                            {row.code.includes('funeral') ||
                              (row.code.includes('death') && hasMDC) ||
                              get(row, 'coverageAmount') ? (
                              <CoverageAmount
                                data={row}
                                values={get(values, `coverage.${row.code}`)}
                                strings={strings}
                                disabled={readOnly}
                              />
                            ) : undefined}
                            <HiddenField field="selected" initialValue />
                          </TableCell>
                        </Scope>
                      </TableRow>
                    ) : undefined
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Scope>
        </Grid>
      );
    }
    return '';
  }
}

CoverageFieldsComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  package: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  covered: PropTypes.object.isRequired,
  // eslint-disable-next-line
  coverage: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  selectedPackage: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    lang: PropTypes.string,
  }),
};
CoverageFieldsComponent.defaultProps = {
  i18n: { lang: 'fr' },
};

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 1,
    overflowX: 'auto',
  },
  table: {
    minWidth: 350,
  },
});

export default withStyles(styles)(CoverageFieldsComponent);
